import { useContent } from "../../../../../contexts/contentContext/contentContext";
import { useModal } from "../../../../../contexts/modalContext/modalContext";
import Button from "../../../../Elements/Button/Button";

import styles from "./styles.module.scss";

/**
 * This component displays a message indicating
 * that changing from yearly to monthly subscription is not allowed.
 */

const UpdateYearlyToMonthlyDenied = () => {
  const { getTextByKey } = useContent();
  const { setModal } = useModal();

  const handleClose = () => {
    setModal({});
  };

  return (
    <div className={styles.updateYearlyToMonthlyDeniedWrapper}>
      <h1 className={styles.title}>
        {getTextByKey("cannot-change-yearly-to-monthly-title")}
      </h1>
      <p className={styles.description}>
        {getTextByKey("cannot-change-yearly-to-monthly")}
      </p>
      <div className={styles.buttons}>
        <Button onClick={handleClose}>{getTextByKey("close")}</Button>
      </div>
    </div>
  );
};

export default UpdateYearlyToMonthlyDenied;
